module.exports = __webpack_public_path__ + "img/Feature.1ec9e463.png";